<div
  [ngClass]="{'order-entry__panel-more__hold-stp__container': true,
			'order-entry__panel-more__hold-stp__container--checked': data.value && !data.locked,
			'order-entry__panel-more__hold-stp__container--unchecked': !data.value && !data.locked,
			'order-entry__panel-more__hold-stp__container--locked': data.locked}"
>
  <p-checkbox
    class="bfx-checkbox-bold-sm bfx-checkbox-bold-unsized"
    [label]="data.label"
    [binary]="true"
    [disabled]="data.locked || !data.enabled"
    [(ngModel)]="data.value"
    (ngModelChange)="onValueChange()"
  >
  </p-checkbox>
</div>
